<template>
    <div class="month_record_panel">
        <div class="header">
            <div class="title">
                <div class="icon"></div>
                {{ `${isCurrentMonth ? '本月' : scoreSummary.month + '月'}` }}
            </div>
            <div class="desc">
                获得 <span class="highlight">{{ scoreSummary.gainedScore }}</span> 已过期
                {{ scoreSummary.expiredScore }}
            </div>
        </div>
        <div class="line"></div>
        <div
            class="record_box"
            :class="{ border_none: index === scoreSummary.scoreLogs.length - 1 }"
            v-for="(item, index) in scoreSummary.scoreLogs"
            :key="item.timestamp"
        >
            <div class="block">
                <div class="title">{{ item.remark }}</div>
                <div class="date">{{ item.timestamp | dateFormat('Lllmm') }}</div>
            </div>
            <div class="score">
                {{ item.score > 0 ? `+${item.score}` : `${item.score}` }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MonthRecordPanel',
    props: {
        scoreSummary: {
            type: Object,
            default: () => ({
                scoreLogs: []
            })
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        isCurrentMonth() {
            return this.scoreSummary.month === new Date().getMonth() + 1;
        }
    }
};
</script>

<style lang="less" scoped>
.month_record_panel {
    width: 347px;
    min-height: 133px;
    background: #ffffff;
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 22px 18px 18px;
        .title {
            font-size: 14px;
            font-weight: bold;
            color: #212121;
            display: flex;
            flex-flow: row;
            align-items: center;
            .icon {
                width: 4px;
                height: 12px;
                background: #fd8e00;
                border-radius: 0px 2px 2px 0px;
                margin-right: 6px;
            }
        }
        .desc {
            font-size: 13px;
            color: #999393;
            .highlight {
                color: #ff550c;
            }
        }
    }
    .line {
        width: 311px;
        height: 0.5px;
        color: #dedede;
        border-bottom: 1px dashed;
        margin: 0 auto;
    }
    .record_box {
        margin-left: 18px;
        margin-right: 18px;
        padding-right: 10px;
        height: 79px;
        border-bottom: 0.5px solid #e7e7e7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        .title {
            width: 65px;
            height: 17px;
            font-size: 16px;
            font-weight: bold;
            color: #002a3c;
            line-height: 17px;
            white-space: nowrap;
        }
        .date {
            margin-top: 7px;
            font-size: 12px;
            color: #9faab5;
        }
        .score {
            text-align: right;
            font-size: 20px;
            font-family: uni_sans_regular;
            color: #002a3c;
        }
    }
    .border_none {
        border: none;
    }
}
</style>